module.exports = ".sw-notice{\r\n    display: flex;\r\n}"